import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Start emotion analysis for an analysis parent
 */
export function startEmotionAnalysis(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/emotion-analysis/start`;
    return axios.post(url, {}, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}

/**
 * Get emotion analysis results for an analysis parent
 */
export function getEmotionAnalysisResults(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/emotion-analysis/results`;
    return axios.get(url, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}

/**
 * Cancel a running emotion analysis
 */
export function cancelEmotionAnalysis(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/emotion-analysis/cancel`;
    return axios.post(url, {}, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}